import { render, staticRenderFns } from "./BrFooter.vue?vue&type=template&id=1d97473a&"
import script from "./BrFooter.vue?vue&type=script&lang=js&"
export * from "./BrFooter.vue?vue&type=script&lang=js&"
import style0 from "./BrFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports